module.exports = __webpack_public_path__ + "static/media/profile.1cf40feb.jpg";